import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeFormat',
  standalone: true
})
export class TimeFormatPipe implements PipeTransform {

  transform(time: string): string {
    if (!time) return '';

    // Verificar si ya contiene AM/PM para evitar duplicación
    if (time.includes('AM') || time.includes('PM')) {
      return time;
    }

    const [hours, minutes] = time.split(':');
    const hour24 = parseInt(hours, 10);
    const hour12 = hour24 === 0 ? 12 : hour24 > 12 ? hour24 - 12 : hour24;
    const period = hour24 < 12 ? 'AM' : 'PM';

    return `${hour12}:${minutes} ${period}`;
  }

}
